<template>
  <transition v-if="showed" name="fade">
    <div :class="classes">
      <slot></slot>
      <span v-if="errorMessage" v-html="errorMessage"></span>
      <div v-if="closable" class="bx-notification-close" @click="close"></div>
    </div>
  </transition>
</template>
<script>
export default {
  name: "bx-notification",
  props: {
    color: {
      type: String,
      default: "default"
    },
    position: {
      type: String,
      default: ""
    },
    timeout: {
      type: [Number, String],
      default: 0
    },
    closable: {
      type: Boolean,
      default: false
    },
    block: {
      type: Boolean,
      default: false
    },
    novisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showed: false,
      errorMessage: null,
      timeoutHandle: null
    };
  },
  computed: {
    classes() {
      const classes = ["bx-notification"];
      classes.push(`bx-notification-${this.color}`);
      classes.push(`bx-position-${this.position}`);

      if (this.block) {
        classes.push(`bx-notification-block`);
      }

      return classes;
    }
  },
  methods: {
    close() {
      this.showed = false;
    },
    show() {
      this.showed = true;
    },
    showNotification(message) {
      this.showed = true;
      this.errorMessage = message;
      this.setTimeout();
    },
    setTimeout() {
      this.clearTimeout();
      if (parseInt(this.timeout) > 0) {
        this.timeoutHandle = setTimeout(this.close, parseInt(this.timeout));
      }
    },
    clearTimeout() {
      clearTimeout(this.timeoutHandle);
    }
  },
  mounted() {
    this.setTimeout();
    this.showed = !this.novisible;
  }
};
</script>
